<dp-main-view [config]="mainView" [showMenu]="logged" (logout)="logout()"></dp-main-view>